var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "comTop flex" }, [
      _c("div", { staticClass: "flex topBox", staticStyle: { width: "45%" } }, [
        _vm._m(0),
        _c("div", { staticClass: "msgBox" }, [
          _c("p", { staticStyle: { color: "#00FEDD" } }, [
            _c("span", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.sjObj.value)),
            ]),
            _vm._v("(户) "),
          ]),
          _c("p", [_vm._v(_vm._s(_vm.sjObj.name))]),
        ]),
      ]),
      _c("div", { staticClass: "flex topBox", staticStyle: { width: "55%" } }, [
        _vm._m(1),
        _c("div", { staticClass: "msgBox" }, [
          _c("p", { staticStyle: { color: "#00FEDD" } }, [
            _c("span", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.srObj.value)),
            ]),
            _vm._v("(元/年) "),
          ]),
          _c("p", [_vm._v(_vm._s(_vm.srObj.name))]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "comBot flex" }, [
      _c("div", { staticClass: "comleft" }, [
        _c("div", [
          _c("p", [_vm._v(_vm._s(_vm.fxObj.name))]),
          _c("p", [
            _c("span", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.fxObj.value)),
            ]),
            _vm._v("(元/年) "),
          ]),
        ]),
        _c("div", [
          _c("p", [_vm._v(_vm._s(_vm.spObj.name))]),
          _c("p", [
            _c("span", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.spObj.value)),
            ]),
            _vm._v("(元/年) "),
          ]),
        ]),
      ]),
      _c("div", { ref: "chart", staticClass: "chart" }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex imgBox" }, [
      _c("img", {
        staticClass: "fd",
        attrs: { src: require("images/index/lndn/top1.png"), alt: "" },
      }),
      _c("img", {
        staticClass: "dz",
        attrs: { src: require("images/index/lndn/dz.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex imgBox" }, [
      _c("img", {
        staticClass: "fd",
        attrs: { src: require("images/index/lndn/top2.png"), alt: "" },
      }),
      _c("img", {
        staticClass: "dz",
        attrs: { src: require("images/index/lndn/dz.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }